










import Vue from "vue";
import RouteNames from "../router/RouteNames";

type NavItem = {
  routeName?: string;
  icon: string;
  link?: string;
  newTab?: boolean;
  label: string;
};

export default Vue.extend({
  name: "TheNavbar",
  props: ["drawer"],
  data: () => {
    return {
      navItemStart: {
        label: "Start",
        routeName: RouteNames.HOME,
        icon: "fa-home",
      } as NavItem,
      navItemsUser: [
        {
          label: "Campaigns",
          routeName: RouteNames.CAMPAIGN_LIST,
          icon: "fa-drafting-compass",
        },
        { label: "Forces", routeName: RouteNames.FORCE_LIST, icon: "fa-chess" },
      ] as NavItem[],
    };
  },
  computed: {
    navItems(): NavItem[] {
      const result = [this.navItemStart];
      if (this.$user) {
        result.push(...this.navItemsUser);
      }
      return result;
    },
  },
});
